import React, { useContext, useState } from 'react';

import { List, Dropdown, Modal } from 'antd';
import Axios from 'axios';

import styled from 'styled-components';

import { CURRENCIES } from '@configs/CURRENCIES';

import { ListContext } from '@contexts/ListContext';

import { getContactName } from '@hooks/API/Contact/UseContactsList';

import FlexContainer from '@components/Gui/FlexContainer';
import { NwButton } from '@components/Gui/NwButton';
import { NwCard } from '@components/Gui/NwCard/NwCard';
import TransactionCreateDrawer from '@components/Transactions/TransactionsDrawer/TransactionCreateDrawer';
import TransactionDetailDrawer from '@components/Transactions/TransactionsDrawer/TransactionDetailDrawer';

import EventTransactionsListTable from './EventTransactionsListTable';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Title = styled.div`
    font-weight: bold;
`;

const Description = styled.div`
    font-size: 0.65rem;
`;

export const AddTransactionButton = ({ type, ghost, onCreateTransaction }) => {
    switch (type.toLowerCase()) {
        case 'travel':
        case 'followup':
        case 'accommodation':
            return (
                <Dropdown
                    menu={{
                        onClick: onCreateTransaction,
                        items: [
                            { key: 'JobExpense', label: 'Job Expense' },
                            { key: 'JobRefund', label: 'Job Refund' },
                        ],
                    }}
                >
                    <div className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                        <NwButton
                            icon={
                                ghost ? byPrefixAndName.fass['money-bill-alt'] : byPrefixAndName.fasl['money-bill-alt']
                            }
                            ghost={ghost}
                            primary={!ghost}
                            size="small"
                            label="Add Transaction"
                        />
                    </div>
                </Dropdown>
            );
        case 'event':
            return (
                <Dropdown
                    menu={{
                        onClick: onCreateTransaction,
                        items: [
                            { key: 'JobExpense', label: 'Job Expense' },
                            { key: 'JobRefund', label: 'Job Refund' },
                            { key: 'JobFee', label: 'Job Fee' },
                            { key: 'Product', label: 'Product' },
                        ],
                    }}
                >
                    <div className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                        <NwButton
                            icon={
                                ghost ? byPrefixAndName.fass['money-bill-alt'] : byPrefixAndName.fasl['money-bill-alt']
                            }
                            ghost={ghost}
                            primary={!ghost}
                            size="small"
                            label="Add Transaction"
                        />
                    </div>
                </Dropdown>
            );
        default:
            return <div />;
    }
};

const EventTransactionsList = ({ event, projectId, readOnly, onTransactionOpen, onTransactionCreatedOrUpdated }) => {
    const [transactionFamily, setTransactionFamily] = useState();
    const [showCreateTransactionDrawer, setShowCreateTransactionDrawer] = useState(false);
    const { GetFamilyName } = useContext(ListContext);

    const handleShowCreateTransactionDrawer = ({ key }) => {
        setTransactionFamily(key);
        setShowCreateTransactionDrawer(true);
    };

    const handleCloseCreateTransactionDrawer = () => {
        setTransactionFamily();
        setShowCreateTransactionDrawer(false);
    };

    let displayedTransactions = event.Transactions
        ? event.Transactions.map((transaction) => ({
              ...transaction,
              key: transaction.ID,
          }))
        : [];

    return projectId ? (
        <NwCard
            title="Event Transactions"
            extra={
                projectId && (
                    <AddTransactionButton type={event.elType} onCreateTransaction={handleShowCreateTransactionDrawer} />
                )
            }
        >
            <List
                itemLayout="horizontal"
                dataSource={displayedTransactions}
                renderItem={(transaction) => {
                    const currency = CURRENCIES.find((item) => item.code === transaction.Currency);
                    return (
                        <List.Item className="ant-list-item-top" onClick={() => onTransactionOpen(transaction)}>
                            <FlexContainer column alignItems="flex-start" fullWidth>
                                <div>{getContactName(transaction.ClientID)}</div>
                                <Description>{`${GetFamilyName(transaction.Family)}/${transaction.Label}`}</Description>
                                <FlexContainer justifyContent="space-between" fullWidth>
                                    <Title>{transaction.Title}</Title>
                                    <div>{`${currency ? currency.symbol : ''}${transaction.SingleFee} `}</div>
                                </FlexContainer>
                            </FlexContainer>
                        </List.Item>
                    );
                }}
            />
            {showCreateTransactionDrawer && (
                <TransactionCreateDrawer
                    event={event}
                    modelSelectionEnabled
                    projectId={projectId}
                    eventType={event.elType}
                    transactionFamily={transactionFamily}
                    onClose={handleCloseCreateTransactionDrawer}
                    onTransactionCreatedOrUpdated={onTransactionCreatedOrUpdated}
                />
            )}
        </NwCard>
    ) : (
        displayedTransactions && displayedTransactions.length !== 0 && (
            <>
                <EventTransactionsListTable
                    transactions={displayedTransactions}
                    isExpanded={true}
                    onTransactionDeletedOrUpdated={onTransactionCreatedOrUpdated}
                />
            </>
        )
    );
};

export default EventTransactionsList;
